import Navbar from "./Components/Navbar";
import MixBlend from "./Components/MixBlend";
import { Signature } from "./Components/Signature";
import "./styles.css";

export default function App() {
  const items = [
    { label: "Inicio", color: "#00639b", action: () => "" },
    { label: "Projects", color: "#ff00ef", action: () => "" },
    { label: "Volunteer", color: "#16b30f", action: () => "" },
  ];
  return (
    <section className="App">
      <Signature />
    </section>
  );
}
